import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5a7a4958"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_2 = { class: "card-body pt-9 pb-0" }
const _hoisted_3 = { class: "d-flex flex-wrap flex-sm-nowrap mb-3" }
const _hoisted_4 = { class: "flex-grow-1" }
const _hoisted_5 = { class: "d-flex justify-content-between align-items-start flex-wrap mb-2" }
const _hoisted_6 = { class: "d-flex flex-column" }
const _hoisted_7 = { class: "d-flex align-items-center mb-2" }
const _hoisted_8 = { class: "text-gray-800 fs-2 fw-bolder me-1" }
const _hoisted_9 = { class: "d-flex my-4" }
const _hoisted_10 = { class: "indicator-label" }
const _hoisted_11 = { class: "svg-icon svg-icon-3 d-none" }
const _hoisted_12 = {
  class: "btn btn-sm btn-primary me-3",
  "data-bs-toggle": "modal",
  "data-bs-target": "#kt_modal_compare_ive_value",
  ref: "compareButtonRef"
}
const _hoisted_13 = { class: "indicator-label" }
const _hoisted_14 = { class: "indicator-progress" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))
const _hoisted_16 = { class: "me-0" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-sm btn-icon btn-bg-light btn-active-color-primary",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "top-end"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-three-dots fs-3" })
], -1))
const _hoisted_18 = { class: "d-flex flex-wrap flex-stack" }
const _hoisted_19 = { class: "d-flex flex-column flex-grow-1 pe-8" }
const _hoisted_20 = { class: "d-flex flex-wrap" }
const _hoisted_21 = { class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3" }
const _hoisted_22 = { class: "d-flex align-items-center" }
const _hoisted_23 = ["data-kt-countup-value"]
const _hoisted_24 = { class: "fw-bold fs-6 text-gray-400" }
const _hoisted_25 = { class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3" }
const _hoisted_26 = { class: "d-flex align-items-center" }
const _hoisted_27 = ["data-kt-countup-value"]
const _hoisted_28 = { class: "fw-bold fs-6 text-gray-400" }
const _hoisted_29 = { class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3" }
const _hoisted_30 = { class: "d-flex align-items-center" }
const _hoisted_31 = ["data-kt-countup-value"]
const _hoisted_32 = { class: "fw-bold fs-6 text-gray-400" }
const _hoisted_33 = { class: "d-flex align-items-center w-200px w-sm-300px flex-column mt-3" }
const _hoisted_34 = { class: "row g-5 g-xl-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_QuickNavDropdown = _resolveComponent("QuickNavDropdown")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_FactorValuesTable = _resolveComponent("FactorValuesTable")!
  const _component_CompareValuesTable = _resolveComponent("CompareValuesTable")!
  const _component_FactorValuesCreating = _resolveComponent("FactorValuesCreating")!
  const _component_FactorValuesComparing = _resolveComponent("FactorValuesComparing")!
  const _component_FactorValuesEditing = _resolveComponent("FactorValuesEditing")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.can('read', 'ive'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("h4", _hoisted_8, _toDisplayString(_ctx.translate('instantValueEstimatorPanel')), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("button", {
                      class: "btn btn-sm btn-primary me-3",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.ClonArea(_ctx.selectedArea)))
                    }, [
                      _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.translate('areaClone')), 1)
                    ]),
                    _withDirectives(_createElementVNode("button", {
                      class: "btn btn-sm btn-light me-2",
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.resetComparing && _ctx.resetComparing(...args)))
                    }, [
                      _createElementVNode("span", _hoisted_11, [
                        _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr012.svg" })
                      ]),
                      _createTextVNode(" " + _toDisplayString(_ctx.translate('cancel')), 1)
                    ], 512), [
                      [_vShow, _ctx.comparing]
                    ]),
                    _createElementVNode("button", _hoisted_12, [
                      _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.translate(!_ctx.comparing ? 'areaCompare' : 'anotherCompare')), 1),
                      _createElementVNode("span", _hoisted_14, [
                        _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                        _hoisted_15
                      ])
                    ], 512),
                    _createElementVNode("div", _hoisted_16, [
                      _hoisted_17,
                      _createVNode(_component_QuickNavDropdown)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("div", {
                            class: "fs-2 fw-bolder",
                            "data-kt-countup": "true",
                            "data-kt-countup-value": _ctx.areas.length
                          }, _toDisplayString(_ctx.areas.length), 9, _hoisted_23)
                        ]),
                        _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.translate('areas')), 1)
                      ]),
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("div", _hoisted_26, [
                          _createElementVNode("div", {
                            class: "fs-2 fw-bolder",
                            "data-kt-countup": "true",
                            "data-kt-countup-value": _ctx.factorsValues.length
                          }, _toDisplayString(_ctx.factorsValues.length), 9, _hoisted_27)
                        ]),
                        _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.translate('factors')), 1)
                      ]),
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("div", _hoisted_30, [
                          _createElementVNode("div", {
                            class: "fs-2 fw-bolder",
                            "data-kt-countup": "true",
                            "data-kt-countup-value": _ctx.numberOfValues
                          }, _toDisplayString(_ctx.numberOfValues), 9, _hoisted_31)
                        ]),
                        _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.translate('totalValues')), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_33, [
                    _createVNode(_component_Multiselect, {
                      modelValue: _ctx.selectedArea,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedArea) = $event)),
                      searchable: true,
                      required: true,
                      canDeselect: false,
                      options: _ctx.areas,
                      label: "areaName",
                      trackBy: "areaName",
                      valueProp: "id",
                      noResultsText: _ctx.translate('noResultsFound'),
                      onChange: _ctx.handleAreaChange
                    }, null, 8, ["modelValue", "options", "noResultsText", "onChange"])
                  ])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_34, [
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.primaryAreaClasses)
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.factorsValues, (value, key) => {
          return (_openBlock(), _createBlock(_component_FactorValuesTable, {
            key: key,
            value: value,
            comparing: _ctx.comparing,
            onShowCreateModal: _ctx.showFactorCreateModal,
            onShowEditModal: _ctx.showFactorEditModal
          }, null, 8, ["value", "comparing", "onShowCreateModal", "onShowEditModal"]))
        }), 128))
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.secondaryAreaClasses)
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.compareFactorsValues, (value, key) => {
          return (_openBlock(), _createBlock(_component_CompareValuesTable, {
            key: key,
            value: value
          }, null, 8, ["value"]))
        }), 128))
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.tertiaryAreaClasses)
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.secondCompareFactorsValues, (value, key) => {
          return (_openBlock(), _createBlock(_component_CompareValuesTable, {
            key: key,
            value: value
          }, null, 8, ["value"]))
        }), 128))
      ], 2)
    ]),
    _createVNode(_component_FactorValuesCreating, {
      onNewValueCreated: _ctx.refreshValues,
      "factor-data": _ctx.factorData
    }, null, 8, ["onNewValueCreated", "factor-data"]),
    _createVNode(_component_FactorValuesComparing, {
      "factor-data": _ctx.compareFactorsValues,
      onCompareRequested: _ctx.initCompare
    }, null, 8, ["factor-data", "onCompareRequested"]),
    _createVNode(_component_FactorValuesEditing, {
      "edit-data": _ctx.editData,
      onNewValueCreated: _ctx.refreshValues
    }, null, 8, ["edit-data", "onNewValueCreated"])
  ], 64))
}